import { createSelectorCreator, defaultMemoize } from 'reselect';
import _ from 'lodash';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);

const selectSeriesDetailSeriesData = state => state.seriesDetail.seriesData;
const selectSeriesDetailInline = state => state.seriesDetail.inline;
const selectSeriesDetailTabs = state => state.seriesDetail.tabs;
const selectSeriesDetailLatestEpisode = state => state.seriesDetail.latestEpisode;
const selectSeriesDetailPromos = state => state.seriesDetail.promos;
const selectSeriesDetailSeo = state => state.seriesDetail.seo;
const selectSeriesDetailRecommendedPanel = state => state.seriesDetail.recommendedPanel;

export const makeSelectSeriesDetailRecommendedPanel = createDeepEqualSelector(
  selectSeriesDetailRecommendedPanel,
  recommendedPanel => recommendedPanel,
);

export const makeSelectSeriesDetailSeriesData = createDeepEqualSelector(
  selectSeriesDetailSeriesData,
  seriesData => seriesData,
);

export const makeSelectSeriesDetailInline = createDeepEqualSelector(
  selectSeriesDetailInline,
  inline => inline,
);

export const makeSelectSeriesDetailTabs = createDeepEqualSelector(
  selectSeriesDetailTabs,
  tabs => tabs,
);

export const makeSelectSeriesDetailLatestEpisode = createDeepEqualSelector(
  selectSeriesDetailLatestEpisode,
  latestEpisode => latestEpisode,
);

export const makeSelectSeriesDetailPromos = createDeepEqualSelector(
  selectSeriesDetailPromos,
  promos => promos,
);

export const makeSelectSeriesDetailSeo = createDeepEqualSelector(selectSeriesDetailSeo, seo => seo);
